export enum SuggestionViewEnum {
  LIST = 'list',
  MAP = 'map',
}
